module.exports = __webpack_public_path__ + "img/arrow_down.9f9d6e88.svg";